module.exports = __webpack_public_path__ + "static/media/hengshan_web.40b7da92.webp";